import { parseJsonText } from "../jsonText.js";
function object(value) {
  const parsed = parseJsonText(value);
  if (parsed == null || parsed === "") return {};
  if (typeof parsed !== "object" || Array.isArray(parsed)) throw new Error("Invalid advertising settings.");
  return parsed;
}
// Read compatibility only. Retain legacy data without executing slot code.
export function advertisingSettings(settings = {}) {
  const legacy = object(settings.ads), current = object(settings.advertising);
  return { ...legacy, ...current, slots: { ...object(legacy.slots), ...object(current.slots) } };
}
export function mergeAdvertisingSettings(current, patch, { allowAdsTxt = false } = {}) {
  const latest = object(current), incoming = { ...object(patch) };
  if (!allowAdsTxt) delete incoming.adsTxt;
  return { ...latest, ...incoming, slots: { ...object(latest.slots), ...object(incoming.slots) } };
}
